<template>
  <div>
    <div class="navbar-brand">
      <div>
        <img src="../assets/imgs/logo.png" alt="logo" class="top-logo">
      </div>
      <div class="button-row">
        <router-link to="/"><v-btn text>Hem</v-btn></router-link>
        <router-link to="/tjanster"><v-btn text>Tjänster</v-btn></router-link>
        <router-link to="/om"><v-btn text>Om oss</v-btn></router-link>
        <router-link to="/kontakt"><v-btn text>Kontakt</v-btn></router-link>
        <router-link to="/support"><v-btn text>Support</v-btn></router-link>
        <router-link to="/drift"><v-btn text>Driftstatus</v-btn></router-link>
        <!-- <a href="https://www.smartasystem.se/projektsystem"><v-btn text>Mina Sidor</v-btn></a> -->
    </div>
    <div class="button-row-mobile">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text style="margin-right: 20px;"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list class="mobile-button">
        <v-list-item><v-list-item-title><router-link to="/"><v-btn text>Hem</v-btn></router-link></v-list-item-title></v-list-item>
        <v-list-item><v-list-item-title><router-link to="/tjanster"><v-btn text>Tjänster</v-btn></router-link></v-list-item-title></v-list-item>
        <v-list-item><v-list-item-title><router-link to="/om"><v-btn text>Om oss</v-btn></router-link></v-list-item-title></v-list-item>
        <v-list-item><v-list-item-title><router-link to="/kontakt"><v-btn text>Kontakt</v-btn></router-link></v-list-item-title></v-list-item>
        <v-list-item><v-list-item-title><router-link to="/support"><v-btn text>Support</v-btn></router-link></v-list-item-title></v-list-item>
        <v-list-item><v-list-item-title><router-link to="/drift"><v-btn text>Driftstatus</v-btn></router-link></v-list-item-title></v-list-item>
        <!-- <v-list-item><v-list-item-title> <a href="https://www.smartasystem.se/projektsystem"><v-btn text>Mina Sidor</v-btn></a></v-list-item-title></v-list-item> -->

       
      </v-list>
    </v-menu>
  </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Navbar',
  data() {
    return {
    }
  },
  methods: {
    logout(){
      // Kallar på script i Globalmixins som tar bort alla cookies och loggar ut från API:et
      this.logOutAndClearCookies();
      this.hideLogoutModal();
    },
    // Visar logga-ut-modal
    showLogoutModal() {
      this.$refs['logout-modal'].show();
    },
    hideLogoutModal() {
      this.$refs['logout-modal'].hide();
    },
  }
}
</script>

<style scoped lang="scss">
// .v-menu__content.theme--light.menuable__content__active {
//   min-width: 64px;
//     top: 64px;
//     right: 0;
//     transform-origin: right top;
//     z-index: 8;
// }

  .v-list {
    padding:0!important;
  }

.mobile-button {
  .v-list-item {
    padding: 0px;
  }
  button {
    width: 100%;
  }
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 64px;
    min-width: 64px;
    padding: 0 16px;
}
.v-btn {
    border-radius: 0px;
}

.button-row {
  float: right;
    button{
    background: transparent;
    border: transparent;
  }
}
.top-logo {
  // position: absolute;
  //   left: 0;
}
// .icon-white{
//   color: #ffffff;
// }
.navbar-brand {
  height: 64px;
  width:100%;
  display:flex;
  justify-content:space-between;
  align-items: center;
  img {
    height:30px;margin-left:60px;
  }
}
.button-row {
  display: block;
}
.button-row-mobile {
  display: none;
}
@media screen and (max-width: 768px) {
  .navbar-brand {
  img {
    height:30px;margin-left:20px;
  }
}
}
@media screen and (max-width: 1040px) {
  .button-row {
    display: none;
  }
  .button-row-mobile {
    display: block;
  }
}
</style>
